import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { HitExistsPayload } from './exists.interface';
import { ExistsService } from './exists.service';

const service = new ExistsService();

export interface ExistsState {}

const ExistsStore: Module<ExistsState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async checkIfExists(context, payload: HitExistsPayload) {
         const response = await service.checkIfExist(payload);
         return response;
      },
   },
};

export default ExistsStore;
